import { useDetails as useDetailsContext } from "../../../context/details";

export const useDetails = () => {
  const { activeTab, data, isDataLoading } = useDetailsContext();

  return {
    activeTab: activeTab.id,
    data,
    isDataLoading
  }
}
